import { useEffect, useState } from "react";
import { OPENING } from "../lib/site";

// Melbourne wall-clock "now" as a pseudo-UTC timestamp.
const melbNow = () => {
  const p = Object.fromEntries(
    new Intl.DateTimeFormat("en-AU", {
      timeZone: "Australia/Melbourne", hourCycle: "h23",
      year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit",
    }).formatToParts(new Date()).map((x) => [x.type, x.value])
  );
  return new Date(Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second));
};

const compute = () => {
  const now = melbNow();
  if (now.getTime() < OPENING) return split(OPENING - now.getTime(), "Grand opening in");
  const dow = now.getUTCDay();
  const h = now.getUTCHours();
  if ((dow === 5 && h >= 21) || (dow === 6 && h < 4)) return { live: true };
  const t = new Date(now);
  t.setUTCDate(now.getUTCDate() + ((5 - dow + 7) % 7));
  t.setUTCHours(21, 0, 0, 0);
  if (t <= now) t.setUTCDate(t.getUTCDate() + 7);
  return split(t - now, "Next Friday in");
};

const split = (ms, label) => {
  const s = Math.floor(ms / 1000);
  return { label, d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
};

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ testid = "countdown" }) => {
  const [c, setC] = useState(compute);
  useEffect(() => {
    const t = setInterval(() => setC(compute()), 1000);
    return () => clearInterval(t);
  }, []);

  if (c.live) {
    return (
      <div className="flex items-center gap-3" data-testid={`${testid}-live`}>
        <span className="relative flex h-2.5 w-2.5"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[var(--glow)] opacity-75" /><span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[var(--glow)]" /></span>
        <span className="font-mono-x text-xs uppercase tracking-[0.25em] text-[var(--glow)]">Doors are open — tonight</span>
      </div>
    );
  }

  return (
    <div data-testid={testid}>
      <p className="eyebrow mb-2 text-center sm:text-left">{c.label}</p>
      <div className="flex items-end justify-center gap-4 sm:justify-start sm:gap-6">
        {[["Days", c.d], ["Hrs", c.h], ["Min", c.m], ["Sec", c.s]].map(([k, v]) => (
          <div key={k} className="text-center">
            <div className="font-display text-3xl tabular-nums text-[#F8F6F0] sm:text-4xl">{pad(v)}</div>
            <div className="font-mono-x text-[11px] uppercase tracking-[0.25em] text-[var(--stone)]">{k}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
